
import apiClient from "../helpers/apiClient";

const API = `/api/v2/evaluations`
const api = apiClient();

export const getEvaluationByRestos = () => api.get(`${API}/byrestos`);
export const getEvaluationByResto = () => api.get(`${API}/byresto`);
export const getEvaluationRestoById = (id) => api.get(`${API}/byresto/${id}`);
export const getEvaluationByHostId = (id) => api.get(`${API}/byhost/${id}`);
export const sendEvaluation = (data) => api.post(`${API}`, data);
export const getQuestions = (country) => api.get(`${API}/custom-questions/${country}`);
